module.exports = __webpack_public_path__ + "img/login_pic.b24e61f4.png";